<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/studentWorld"></imgBigCards>

    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 面包屑 -->
    <!-- <div class="title-left">
      <el-breadcrumb>
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/layout/list/studentWorld"
          >学生天地</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识干货</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->

    <!--模块2  -->
    <div class="box-content">
      <div class="content-left">
        <KnowledgeCards2
          v-for="(item, index) in mydata.articleListArr"
          :key="index"
          :info="item"
        ></KnowledgeCards2>

        <!-- 空白内容组件 -->
        <glEmpty v-if="mydata.articleListArr.length === 0"></glEmpty>

        <!-- 模块3 -->
        <!--分页 -->
        <div class="gl-pagination">
          <el-pagination
            v-model:currentPage="mydata.pageObj.currentPage"
            v-model:page-size="mydata.pageObj.pageSize"
            :total="mydata.pageObj.total"
            layout="prev, pager, next"
        pager-count="4"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <!-- 右侧推荐区域 -->
      <div class="content-right">
        <rightCardGreatValue title="超值推荐"></rightCardGreatValue>
      </div>
    </div>
  </div>
</template>
  
<script>
// 是否来自其他模块
let fromOtherModule = false;
// 是否来自综合模块
let fromCompositeModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "checkTheProcessList",
  beforeRouteEnter(to, from, next) {
    // 如果是来自看流程综合页面，那么把fromCompositeModule设置成true值
    if (from.path === "/layout/list/checkTheProcess") {
      fromCompositeModule = true;
    }

    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/checkTheProcessDetails",
        "/layout/list/checkTheProcess",
        // "/layout/list/topicSubjectDetails",
        // "/layout/list/onlineDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>


<script setup>
// 超值推荐
import rightCardGreatValue from "@/components/rightCardGreatValue/index2.vue";

// 必备好书
// import rightCardBook from "@/components/rightCardBook/index.vue";
// 必刷好题
// import rightCardProblem from "@/components/rightCardProblem/index.vue";
// 必学好课
// import rightCardCourse from "@/components/rightCardCourse/index.vue";

import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";

import KnowledgeCards2 from "@/components/KnowledgeCards2/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

// 引入接口
// import { articleSearchList } from "@/api/studentWorld/index.js";
// 引入接口
import { articleList } from "@/api/home/index.js";

// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive, onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // path: "/layout/list/KnowledgeDetails",
  articleListArr: [], // 文章列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 8, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId("/layout/list/checkTheProcess"), // 栏目id值
    search: "", // 搜索查询
  },
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    // 基础地址
    mydata.VUE_APP_BASE_HOST = process.env.VUE_APP_BASE_HOST;
    mydata.path = "/layout/list/KnowledgeDetails";
    mydata.articleListArr = []; // 文章列表
    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 8, // 每页条数
      total: 0, // 总的条数
    };
    mydata.form = {
      column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询
    };
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();

    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }

  // 如果是从综合页面跳转进来的，那么就获取path参数，并且查询列表
  if (fromCompositeModule) {
    mydata.pageObj.currentPage = 1;
    mydata.form.search = route.query.search;
    articleListFn();
    // 重置fromCompositeModule成false值
    fromCompositeModule = false;
  }
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // console.log(res.data.list,"文章")
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  articleListFn();
}

// 查询
// articleListFn();
</script>
  
<style scoped lang="scss">
.my-rightLi {
  > p:nth-of-type(1) {
    width: calc(100% - 0px); // 减去0px而不是减去100px，是因为右侧没有时间文字
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.taoBao {
  // background-color: #ffffff;
  background-color: #f9f9f9;
  padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

 ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    margin-bottom: 16px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }


  
  ///////模块3
  .box-content {
    // width: 1200px;
    // height: 1301px;
    margin: 0 auto;
    // border: 1px solid blue;
    // padding: 30px;
    // border-radius: 8px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    // overflow: hidden;
    // overflow: visible;
    //////左边
    .content-left {
      width: 343px;
      margin: 0 auto;
      // border:1px solid red;
      .detail {
        margin-bottom: 16px;
      }
      .detail:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
  
  .content-right{
   :deep(.box-column.column3){
    margin-bottom:0px;
  }
  }
  

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    // margin-bottom: 40px;
    // border:1px solid red;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
  